import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/design-tokens.css'
import './assets/css/styles.css'
import './assets/css/responsive.css'
import './assets/css/fonts.css'
import './assets/css/app.css'
import './assets/css/responsive-fix.css'
import 'react-toastify/dist/ReactToastify.css';
// CSS cua react-datepicker phai nap TOAN CUC: 153 man dung <DatePicker> nhung chi 52 man
// tu import CSS nay. Man nao khong import ma duoc mo truc tiep (chunk lazy rieng) thi lich
// hien khong style - dung mot cot chu tran ra ngoai. Vd: Bao cao diem danh CLB.
import 'react-datepicker/dist/react-datepicker.css';
import Layout from "./components/Layout";
import Sidebar from "./components/Sidebar";
import {
    Routes,
    Route,
    Navigate
} from "react-router-dom";
import React, { Suspense } from "react";
import {RedirectAuth, RequireAuth} from "./utils/common";
import { ToastContainer } from 'react-toastify';
import {getAccessToken} from "./utils/authority";
import {RouteErrorBoundary} from "./components/core/ErrorBoundary";

// Lazy load routes for code splitting
const Home = React.lazy(() => import("./routes/home"));
const QuickAccessHome = React.lazy(() => import("./routes/admin/quick-access-home"));
const Admin = React.lazy(() => import("./routes/admin"));
const AuthSas = React.lazy(() => import("./routes/authsas"));
const DeleteAccount = React.lazy(() => import("./routes/delete-account"));
const Privacy = React.lazy(() => import("./routes/privacy"));
const NotFound = React.lazy(() => import("./routes/not-found"));

// Loading fallback component
const LoadingFallback = () => (
    <div className="d-flex justify-content-center align-items-center" style={{height: '100vh'}}>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
);

const AdminLoadingFallback = () => (
    <div className="container">
        <div className="row">
            <Sidebar />
            <div className="mb-4 col-md-10 tab-content">
                <div className="d-flex justify-content-center align-items-center" style={{minHeight: '320px'}}>
                    <div className="text-center text-muted">
                        <div className="spinner-border text-primary mb-3" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <div>Đang tải nội dung…</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);
class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuth: false
        }
    }
    componentDidMount() {
        let token = getAccessToken();
        this.setState({isAuth: !!token});
        if (process.env.NODE_ENV === 'development') {
            console.log("Version ReactJs", React.version);
        }
    }
    render() {
        return (
            <Layout>
                <Suspense fallback={<LoadingFallback />}>
                  <RouteErrorBoundary>
                    <Routes>
                        <Route
                            path="/"
                            element={
                                <RequireAuth redirectTo="/dang-nhap">
                                    <Navigate to="/ad-sas-school" replace />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/ad-sas-school"
                            element={
                                <RequireAuth redirectTo="/dang-nhap">
                                    <Suspense fallback={<AdminLoadingFallback />}>
                                        <RouteErrorBoundary withSidebar>
                                            <QuickAccessHome />
                                        </RouteErrorBoundary>
                                    </Suspense>
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/ad-sas-school/*"
                            element={
                                <RequireAuth redirectTo="/dang-nhap">
                                    <Suspense fallback={<AdminLoadingFallback />}>
                                        <RouteErrorBoundary withSidebar>
                                            <Admin />
                                        </RouteErrorBoundary>
                                    </Suspense>
                                </RequireAuth>
                            }
                        />
                        <Route
                            path="/dang-nhap"
                            element={
                                <RedirectAuth redirectTo="/ad-sas-school">
                                    <AuthSas />
                                </RedirectAuth>
                            }
                        />
                        <Route path="/home/*" element={<Home/>}/>
                        <Route path="/yeu-cau-xoa-tai-khoan" element={<DeleteAccount/>}/>
                        <Route path="/privacy" element={<Privacy/>}/>
                        <Route path="*" element={<NotFound/>}/>
                    </Routes>
                  </RouteErrorBoundary>
                </Suspense>
                <ToastContainer />
            </Layout>
        );
    }
}
export default  App;
